import {
    unwrapBulletList,
    unwrapDescriptionList,
    unwrapNumberedList,
    wrapInBulletList,
    wrapInDescriptionList,
    wrapInNumberedList,
    ancestorListType,
} from "./lists.js";
import { minimumListDepthForSelection } from "../utils/tree-operations/ancestors.js";

export const indentDecrease = (view) => {
    if (minimumListDepthForSelection(view.state) < 2) {
        return false;
    }

    switch (ancestorListType(view.state)) {
        case "itemize":
            return unwrapBulletList(view);
        case "enumerate":
            return unwrapNumberedList(view);
        case "description":
            return unwrapDescriptionList(view);
        default:
            return false;
    }
};

export const cursorIsAtStartOfListItem = (state) =>
    state.selection.ranges.every((range) => {
        const line = state.doc.lineAt(range.from);
        const prefix = state.sliceDoc(line.from, range.from);
        return /\\item\s*$/.test(prefix);
    });

export const indentIncrease = (view) => {
    if (minimumListDepthForSelection(view.state) < 1) {
        return false;
    }

    switch (ancestorListType(view.state)) {
        case "itemize":
            return wrapInBulletList(view);
        case "enumerate":
            return wrapInNumberedList(view);
        case "description":
            return wrapInDescriptionList(view);
        default:
            return false;
    }
};
